import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import Layout, { useSEO } from "@/components/Layout";
import { Section, Overline, BlueRule, Button } from "@/components/primitives";

export default function Books() {
  const [books, setBooks] = useState([]);
  useSEO({ title: "Books | Impactful Mindset", description: "Books on mindset, discipline and intentional living from Impactful Mindset." });
  useEffect(() => { api.get("/books").then((r) => setBooks(r.data)); }, []);

  return (
    <Layout>
      <Section className="pt-20 pb-10">
        <Overline>Books</Overline>
        <h1 className="font-serif-display text-4xl sm:text-5xl font-bold mt-4 text-[#111827]">The Impactful Mindset library</h1>
        <BlueRule className="mt-6" />
        <p className="text-lg text-slate-600 mt-6 max-w-2xl leading-relaxed">
          Practical books designed to change how you think—and, through it, how you live.
        </p>
      </Section>

      <Section className="pb-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {books.map((book) => (
            <Link key={book.id} to={`/books/${book.slug}`} data-testid={`book-card-${book.slug}`}
              className="group border border-slate-200 hover:border-[#0F2C59] transition-colors p-6 flex flex-col">
              <div className="aspect-[3/4] bg-slate-100 overflow-hidden mb-5">
                <img src={book.cover_image} alt={book.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
              </div>
              {book.status === "coming_soon" && <Overline className="!text-slate-400 mb-1">Coming Soon</Overline>}
              <h2 className="font-serif-display text-xl font-semibold text-[#111827] group-hover:text-[#0F2C59] transition-colors">{book.title}</h2>
              <p className="text-slate-500 text-sm mt-2 font-serif-display italic">{book.subtitle}</p>
              <p className="text-slate-600 text-sm mt-3 leading-relaxed flex-1">{book.short_description}</p>
              <span className="text-sm font-semibold text-[#0F2C59] mt-5">View the book →</span>
            </Link>
          ))}
        </div>
      </Section>
    </Layout>
  );
}
